import { AXES, TYPE_RESULT_RING_IDS } from './data'

export const buildDiagnosisResult = (answers, ringDetails = {}, translations = {}) => {
    const scores = buildScores(answers);
    const axisKeys = Object.keys(AXES).map(axis => pickAxisWinner(axis, scores));
    const typeKey = axisKeys.join('-');

    return buildDiagnosisResultFromTypeKey(typeKey, ringDetails, translations, scores);
};

export const buildDiagnosisResultFromTypeKey = (typeKey, ringDetails = {}, translations = {}, scores = {}) => {
    if (!isValidTypeKey(typeKey)) return null;

    const resultTranslations = translations.results || {};
    const axisLabelTranslations = translations.axisLabels || translations.axis_labels || {};
    const axisDescriptionTranslations = translations.axisDescriptions || translations.axis_descriptions || {};
    const typeResult = resultTranslations[typeKey] || {};
    const ringIds = TYPE_RESULT_RING_IDS[typeKey];
    const axisKeys = typeKey.split('-');
    const axisItems = axisKeys.map(key => {
        return {
            key,
            label: axisLabelTranslations[key] || key,
            description: axisDescriptionTranslations[key] || ''
        };
    });

    return {
        typeKey,
        prefType: typeResult.name,
        prefTypeCaption: typeResult.caption,
        prefDesc: typeResult.intro,
        primaryAxisLabel: axisItems.map(axis => axis.label).join(' × '),
        axisItems,
        designStyleTitle: typeResult.designStyleTitle || typeResult.design_style_title,
        designStyleText: typeResult.designStyleText || typeResult.design_style_text,
        recommendedDesigns: typeResult.recommendedDesigns || typeResult.recommended_designs || [],
        rings: ringIds.map(ringId => buildRingResult(ringId, ringDetails)),
        scores
    };
};

export const isValidTypeKey = (typeKey) => {
    return Object.prototype.hasOwnProperty.call(TYPE_RESULT_RING_IDS, typeKey);
};

export const typeKeyToResultCode = (typeKey) => {
    if (!isValidTypeKey(typeKey)) return null;

    return typeKey.split('-').map(axisKey => axisKey.charAt(0).toLowerCase()).join('');
};

export const resultCodeToTypeKey = (code) => {
    if (!code) return null;

    const normalisedCode = code.toLowerCase();
    return Object.keys(TYPE_RESULT_RING_IDS).find(typeKey => typeKeyToResultCode(typeKey) === normalisedCode) || null;
};

const buildRingResult = (ringId, ringDetails) => {
    const detail = ringDetails[ringId] || {};

    return {
        id: ringId,
        name: detail.name || detail.name_ja || `Ring ${ringId}`,
        imageUrl: detail.image_url || null,
        showUrl: detail.show_url || `/collections/show/${ringId}`,
        webMessage: normalizeMessage(detail.webMessage || detail.web_message),
        catchPhrase: normalizeMessage(detail.catchPhrase || detail.catch_phrase)
    };
};

const normalizeMessage = (message) => {
    if (!message) return '';
    return message.trim();
};

const buildScores = (answers) => {
    const scores = {
        Story: 0,
        Essence: 0,
        Individual: 0,
        Universal: 0,
        Explore: 0,
        Select: 0,
        Dialogue: 0,
        Introspection: 0
    };

    Object.keys(answers).forEach(axis => {
        answers[axis].forEach(value => {
            if (value in scores) scores[value]++;
        });
    });

    return scores;
};

const pickAxisWinner = (axis, scores) => {
    const pair = AXES[axis];
    return scores[pair[0]] >= scores[pair[1]] ? pair[0] : pair[1];
};
